const domainSegments = location.hostname.split('.');
const partnerPlatform = domainSegments[domainSegments.length - 2];

export const environment = {
  production: false,
  store: `https://estore-apigw.${partnerPlatform}.dev/v1`,
  store2: `https://estore-apigw.${partnerPlatform}.dev`,
  storeSubdomain: `${partnerPlatform}.dev`,
  partnerPlatformURL: `https://web.${partnerPlatform}.dev`,
  platformURL: 'https://web.fiv5s.dev/',
  editorBaseUrl: 'https://estore-ibling-series.fiv5s.dev',
  partnerPlatform,
};
